import React, { useEffect, useRef, useState } from 'react';
import { createStyleSheet, Divider, IconButton, Text, User, useStyleSheet, View } from '@gopeerproject/ui-kit';
import moment from 'moment-timezone';
import { FileDownloader } from '../../FileDownloader';
export const Header = ({ actions, file, onClose, isFixed = false }) => {
    const styles = useStyleSheet(getStyles);
    const [isHidden, setIsHidden] = useState(!isFixed);
    const container = useRef(null);
    const timeout = useRef(null);
    useEffect(() => {
        if (isFixed)
            return;
        const mouseMoveListener = (e) => {
            setIsHidden(false);
            if (timeout.current)
                clearTimeout(timeout.current);
            if (container.current instanceof HTMLElement &&
                !container.current.contains(e.target))
                timeout.current = setTimeout(() => {
                    setIsHidden(true);
                }, 1000);
        };
        document.addEventListener('mousemove', mouseMoveListener);
        return () => {
            document.removeEventListener('mousemove', mouseMoveListener);
            if (timeout.current)
                clearTimeout(timeout.current);
        };
    }, [isFixed]);
    return (React.createElement(View, { style: [
            styles.container,
            isHidden && styles.hidden,
            isFixed && styles.fixed
        ], ref: container },
        !isFixed && React.createElement(View, { style: styles.gradient }),
        React.createElement(View, { style: styles.details },
            React.createElement(User, { name: file.author.name, type: file.author.type, image: file.author.image, size: 'md', online: false }),
            React.createElement(View, null,
                React.createElement(Text, { type: 'body', size: 'lg', weight: 'semibold' }, file.author.name),
                React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: styles.extraDetails },
                    moment(file.createdAt).fromNow(),
                    " - ",
                    file.name))),
        React.createElement(View, { style: styles.actions },
            actions,
            actions && React.createElement(Divider, { type: 'vertical', style: styles.divider }),
            React.createElement(FileDownloader, { name: file.name, href: file.data }, (download) => (React.createElement(IconButton, { type: 'tertiary', size: 'sm', accent: 'neutral', value: 'arrow-download', onPress: () => {
                    download();
                } }))),
            React.createElement(Divider, { type: 'vertical', style: styles.divider }),
            React.createElement(IconButton, { type: 'tertiary', size: 'sm', accent: 'neutral', value: 'dismiss', onPress: onClose }))));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    container: {
        position: 'absolute',
        top: 0,
        left: 0,
        padding: size.G,
        width: '100%',
        flexDirection: 'row',
        justifyContent: 'space-between',
        zIndex: 9,
        opacity: 1
    },
    hidden: { opacity: 0 },
    fixed: {
        position: 'relative',
        borderBottomWidth: 1,
        borderStyle: 'solid',
        borderBottomColor: color.white.p10,
        marginBottom: 'auto'
    },
    gradient: {
        top: 0,
        left: 0,
        position: 'absolute',
        width: '100%',
        height: 240,
        backgroundImage: 'linear-gradient(180deg, rgba(0, 0, 0, 0.68) 13.54%, rgba(0, 0, 0, 0) 100%)',
        pointerEvents: 'none'
    },
    details: { flexDirection: 'row', gap: size.C },
    extraDetails: { marginTop: 'auto', color: color.white.p68 },
    actions: {
        flexDirection: 'row',
        gap: size.B,
        alignItems: 'center',
        padding: size.B
    },
    divider: { marginHorizontal: size.B, height: size.G, alignSelf: 'center' }
}));
//# sourceMappingURL=Header.js.map